import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { ApiError } from '@services/http/client';
import { forwardingApi } from '@services/api/forwarding';
import { queryKeys } from '@services/api/queryKeys';
import type { Paginated, SenderAggregate } from '@app-types/index';
import type { SenderListParams } from '@services/api/forwarding';

// Per-sender rollup over /forwarding/senders/. Block / unblock continue to flow
// through useSenderBlocks (useForwarding) — this hook is read-only aggregation.
export const useSenders = (
  params: SenderListParams = {},
): UseQueryResult<Paginated<SenderAggregate>, ApiError> =>
  useQuery({
    queryKey: queryKeys.forwarding.senders(params),
    queryFn: () => forwardingApi.senders(params),
  });
